<template>
  <vgloballayout :loading="loading" :error="error" @reload="organizationInfo">
    <div slot="body" class="settings">
      <h1>Данные организации</h1>
      <el-form ref="form" :model="form" label-width="210px" :rules="rules">
        <el-form-item label="Наименование организации">
          <el-input v-model="form.organizationName" size="small"> </el-input>
        </el-form-item>

        <el-form-item label="Директор">
          <el-input v-model="form.director" size="small"> </el-input>
        </el-form-item>

        <el-form-item label="Email" prop="email">
          <el-input v-model="form.email" size="small"> </el-input>
        </el-form-item>

        <el-row type="flex" justify="space-between m-t-25">
          <el-col :span="11">
            <el-form-item
              label="Основной номер телефона"
              prop="phoneNumberParts.basePhoneNumber"
            >
              <el-input
                v-model="form.phoneNumberParts.basePhoneNumber"
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item
              label="Добавочный номер телефона"
              prop="phoneNumberParts.additionalPhoneNumber"
            >
              <el-input
                v-model="form.phoneNumberParts.additionalPhoneNumber"
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="Фактический адрес" class="m-t-25">
          <el-input v-model="form.address" size="small"> </el-input>
        </el-form-item>

        <el-form-item label="Юридический адрес">
          <el-input v-model="form.officeAddress" size="small"> </el-input>
        </el-form-item>

        <el-row type="flex" justify="space-between m-t-25">
          <el-col :span="11">
            <el-form-item label="ИНН">
              <el-input v-model="form.inn" size="small" :disabled="true">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="ОГРН">
              <el-input v-model="form.ogrn" size="small"> </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="Приемные часы">
          <el-input v-model="form.workingTime" size="small"> </el-input>
        </el-form-item>

        <el-form-item label="БИК банка">
          <el-input v-model="form.bik" size="small"> </el-input>
        </el-form-item>

        <el-form-item label="Полное наименование банка">
          <el-input v-model="form.bankName" size="small"> </el-input>
        </el-form-item>

        <el-form-item label="Корреспондентский счет">
          <el-input v-model="form.ks" size="small"> </el-input>
        </el-form-item>

        <el-form-item label="Адрес банка">
          <el-input v-model="form.bankAddress" size="small"> </el-input>
        </el-form-item>
        <el-form-item label="Расчетный счет">
          <el-input v-model="form.rs" size="small"> </el-input>
        </el-form-item>

        <el-form-item class="m-t-25">
          <el-button type="primary" @click="onSubmit" :loading="loadingSub"
            >Сохранить</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </vgloballayout>
</template>

<script>
export default {
  data() {
    const validateEmail = (rule, value, callback) => {
      if (
        !/^[\w\-+]+([.][\w\-+]+)*@(?:[А-Яа-яЁёA-Za-z0-9]+(-([А-Яа-яЁёA-Za-z0-9])+)*\.)+[А-Яа-яЁёA-Za-z]{2,}$/.test(
          value
        )
      ) {
        callback(new Error("Введите корректный Email"));
      } else {
        callback();
      }
    };
    const validatePhone = (rule, value, callback) => {
      if (!/^(\+7|8)\d{10}$/.test(value)) {
        callback(new Error("Введите корректный телефон"));
      } else {
        callback();
      }
    };

    return {
      rules: {
        email: [
          {
            required: true,
            message: "Обязательное поле",
            trigger: "blur"
          },
          {
            validator: validateEmail,
            trigger: "blur"
          }
        ],
        "phoneNumberParts.basePhoneNumber": [
          { validator: validatePhone, trigger: "blur" },
          {
            required: true,
            message: "Обязательное поле",
            trigger: "blur"
          }
        ],
        "phoneNumberParts.additionalPhoneNumber": [
          { max: 4, message: "Не более 4 символов", trigger: "blur" }
        ]
      },
      loading: false,
      error: false,
      loadingSub: false,
      form: {
        id: null,
        organizationName: "",
        director: "",
        address: "",
        officeAddress: "",
        inn: "",
        ogrn: "",
        workingTime: "",
        bik: "",
        bankName: "",
        ks: "",
        bankAddress: "",
        rs: "",
        email: "",
        phoneNumberParts: {
          basePhoneNumber: "",
          additionalPhoneNumber: ""
        }
      }
    };
  },
  mounted() {
    this.organizationInfo();
  },
  methods: {
    async onSubmit() {
      this.$refs["form"].validate(async valid => {
        if (valid) {
          this.loadingSub = true;
          const prepareData = {
            ...this.form,
            phoneNumberParts: {
              ...this.form.phoneNumberParts,
              basePhoneNumber:
                "+7" +
                this.form.phoneNumberParts.basePhoneNumber.slice(
                  this.form.phoneNumberParts.basePhoneNumber.length - 10
                )
            }
          };
          if ("phone" in prepareData) {
            delete prepareData.phone;
          }
          try {
            await this.$store.dispatch("organizationSaveInfo", prepareData);
            this.$message({
              message: "Сохранено",
              type: "success"
            });
          } catch (e) {
            this.$ErrorsMod(e);
          } finally {
            this.loadingSub = false;
            this.organizationInfo();
          }
        }
      });
    },
    async organizationInfo() {
      this.loading = true;
      this.error = false;

      try {
        let query = await this.$store.dispatch("organization");

        for (let key in query) {
          this.form[key] = query[key];
        }
      } catch (e) {
        this.error = this.$ErrorsMod(e);
      }
      this.loading = false;
    }
  }
};
</script>

<style>
.settings .el-form-item {
  margin-bottom: 10px;
}
</style>
